import script from "./Shapes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Shapes.vue?vue&type=script&setup=true&lang=ts"

import "./Shapes.vue?vue&type=style&index=0&id=4426ca3a&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4426ca3a"]])

export default __exports__